// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"toolbar_toolbar__sAG2y","spacer":"toolbar_spacer__S67-O","search":"toolbar_search__3qiR1"};